import { ScoreCardsEditPageStep } from "@/pages/recruit/scorecards/edit/components/scorecards-edit-pages.tsx";
import { ApiScoreCardLong } from "@/types/recruit/scorecard.types.ts";
import { LinkTo, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface ScoreCardEditSidebarProps {
  step: ScoreCardsEditPageStep;
  scoreCard?: ApiScoreCardLong;
}

export function ScoreCardEditSidebar({ step, scoreCard }: ScoreCardEditSidebarProps) {
  const { t } = useTranslation();

  const menuItems = [
    { step: ScoreCardsEditPageStep.details, title: t("common:details") },
    { step: ScoreCardsEditPageStep.questions, title: t("common:questionnaire") },
  ];

  const isLinkAvailable = scoreCard && scoreCard.title.length > 0;

  return (
    <Stack className={"px-6"} gap={"md"}>
      {menuItems.map((item) => {
        const className = step === item.step ? "text-default" : "text-secondary";

        if (!isLinkAvailable) {
          return (
            <Text key={item.step} className={className}>
              {item.title}
            </Text>
          );
        }

        return (
          <LinkTo
            key={item.step}
            to={`/recruitment/scorecards/${scoreCard.id}/setup/${item.step}`}
            variant={"plain"}
            className={className}
          >
            <Text>{item.title}</Text>
          </LinkTo>
        );
      })}
    </Stack>
  );
}
